/****************
 * SIM traders are ours, not the public's.
 *
 * They are seeded test portfolios — SIM: 1kBalance, SIM: 10kBalance and so on —
 * used to exercise the replicator without touching a real trader. The web app
 * has never filtered them, so they appear on the public leaderboard and a user
 * can select one and start a session against a dummy. Mobile has hidden them
 * since 2026-08-28; this is the port, and the parity audit is what surfaced that
 * only one client was doing it.
 *
 * The marker is the `SIM_` prefix on the portfolio id, which is also what the
 * backend keys on: `CreateSubscription` skips the entire roster gate for ids
 * starting `SIM_`, so the prefix is already load-bearing server-side rather than
 * a naming convention this file invented.
 *
 * ⚠️ This hides them in the UI and nothing more. The durable fix is server-side —
 * the backend performs no admin check at all, so anyone calling the API directly
 * still gets them, and a deep link to /traders/SIM_… still resolves. That is
 * item 6b for the backend, alongside the JWT middleware.
 ****************/

/** True for CopyFi's own seeded test portfolios. */
export function isSimTrader(id: string | null | undefined): boolean {
  return typeof id === "string" && id.startsWith("SIM_");
}

/**
 * Drop SIM traders unless the viewer is an admin.
 *
 * Takes the id off each row via a selector rather than assuming a shape, so the
 * same helper serves the roster list and the leaderboard, whose rows disagree
 * about whether the field is `id` or `trader_id`.
 */
export function withoutSimTraders<T>(
  rows: T[] | undefined,
  isAdmin: boolean,
  idOf: (row: T) => string | null | undefined,
): T[] {
  if (!rows) return [];
  if (isAdmin) return rows;
  return rows.filter((row) => !isSimTrader(idOf(row)));
}
